var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.96852 0.177808L0.1858 7.04769C0.0666717 7.16836 0 7.3302 0 7.49871C0 7.66721 0.0666717 7.82905 0.1858 7.94972L6.96852 14.8222C7.02401 14.8785 7.09036 14.9232 7.16364 14.9537C7.23693 14.9843 7.31567 15 7.39522 15C7.47477 15 7.55351 14.9843 7.62679 14.9537C7.70008 14.9232 7.76643 14.8785 7.82192 14.8222C7.93609 14.7068 8 14.5519 8 14.3906C8 14.2292 7.93609 14.0743 7.82192 13.9589L1.44365 7.49871L7.82192 1.03977C7.93569 0.924434 7.99936 0.769794 7.99936 0.608791C7.99936 0.447789 7.93569 0.293149 7.82192 0.177808C7.76643 0.121537 7.70008 0.0768117 7.62679 0.0462728C7.55351 0.0157338 7.47477 0 7.39522 0C7.31567 0 7.23693 0.0157338 7.16364 0.0462728C7.09036 0.0768117 7.02401 0.121537 6.96852 0.177808Z",
    fill: "#42424E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.a303eb9035c979cd2b38cf7bc33451b1.svg";
export { ForwardRef as ReactComponent };